    const es = {
  about: {
    name: "Ulises Lugo",
    subtitle: "Desarrollador Web",
    description: "Soy un apasionado por crear soluciones digitales funcionales y atractivas. Con un amplio conocimiento en Python, React, PHP, PostgreSQL y CSS, y experiencia en desarrollo de aplicaciones web, scripts y sistemas de informacion. Me gusta trabajar en proyectos grandes y pequeños, siempre buscando mejorar mis habilidades y conocimientos.",
    downloadCV: "Descargar CV"
  },
  banner: {
    title: "Ulises Lugo",
    subtitle: "Desarrollador Web"
  },
  skills: {
    title: "Habilidades y Estudios",
    studies: "Estudios",
    universityCareer: "Titulo Universitario",
    universityName: "Universidad Gran Mariscal de Ayacucho",
    graduationDegree: "Ingeniería en Informática",
    coursesTitle: "Cursos Realizados y Reconocimientos",
    viewCourses: "Ver cursos",
    languages: "Idiomas",
    programming: "Programación",
    design: "Diseño",
    tools: "Herramientas",
    knowledge: "Conocimiento",
    studiesCourses: [
      "Introducción a la Ciberseguridad (Cisco)",
      "Cybersecurity Essentials (Cisco)",
      "Packet tracer (Cisco)",
      "Python essentials 1.1 (Cisco)",
      "Participación (2do lugar) Torneo de Programación 2024-1 UGMA",
      "Inglés básico segundo semestre en CEBA-UCV",
      "Redacción de Informes técnicos (INCES)",
      "Básico de supervisión (INCES)",
      "Inteligencia Emocional (PDVSA GAS)"
    ],
    languagesList: [
      { skill: "Español", level: 10 },
      { skill: "Inglés", level: 7 }
    ],
    toolsList: [
      "Git + GitHub",
      "Consola de comandos",
      "Herramientas de IA",
      "Visual Studio Code",
      "Packet Tracer",
      "Unity"
    ],
    knowledgeList: [
      "Diseño de algoritmos y estructuras de datos",
      "Diseño de interfaces de usuario",
      "Bases de datos relacionales",
      "Diseño de redes",
      "Desarrollo ágil de software"
    ]
  },
  projects: {
    title: "Mis Proyectos",
    developedIn: "Desarrollado en"
  },
  whatIDo: {
    title: "Lo que hago",
    intro: "Me especializo en crear soluciones digitales intuitivas y eficientes en múltiples áreas.",
    frontendTitle: "Desarrollo Front-End",
    frontendDesc: "Construcción de interfaces web responsivas y de alto rendimiento usando React, JavaScript y herramientas modernas.",
    designTitle: "Diseño de Interfaces y Componentes",
    designDesc: "Diseño de interfaces amigables y componentes reutilizables para experiencias de usuario fluidas.",
    scriptingTitle: "Scripting y Automatización",
    scriptingDesc: "Creación de scripts y herramientas de automatización para optimizar flujos de trabajo y procesamiento de datos.",
    infoSystemsTitle: "Sistemas de Información",
    infoSystemsDesc: "Desarrollo de sistemas backend robustos y bases de datos para gestionar y proteger datos eficazmente."
  }
};
export default es;
